import * as tslib_1 from "tslib";
import React from 'react';
import { GooglePlusShareCount, FacebookShareCount, PinterestShareCount, RedditShareCount, TumblrShareCount, } from 'react-share';
export var ShareCount = function (_a) {
    var type = _a.type, props = tslib_1.__rest(_a, ["type"]);
    switch (type) {
        case 'google':
            return React.createElement(GooglePlusShareCount, tslib_1.__assign({}, props));
        case 'facebook':
            return React.createElement(FacebookShareCount, tslib_1.__assign({}, props));
        case 'pinterest':
            return React.createElement(PinterestShareCount, tslib_1.__assign({}, props));
        case 'reddit':
            return React.createElement(RedditShareCount, tslib_1.__assign({}, props));
        case 'tumblr':
            return React.createElement(TumblrShareCount, tslib_1.__assign({}, props));
        default:
            return null;
    }
};
ShareCount.displayName = 'ShareCount';
export default ShareCount;
//# sourceMappingURL=ShareCount.js.map